import * as React from "react";

export const CompanyIcon = ({isActive, ...props }: SvgIconProps) => {
  return (
    <svg width={15} height={16} viewBox="0 0 15 16" fill="none" {...props}>
      <g
        opacity={0.3}
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.334 5.9l6.3-4.9 6.3 4.9v7.7a1.4 1.4 0 01-1.4 1.4h-9.8a1.4 1.4 0 01-1.4-1.4V5.9z" />
        <path d="M5.533 15V8h4.2v7" />
      </g>
    </svg>
  );
};
